<script setup lang="ts">
import { ref, computed, onUnmounted } from 'vue'
import { useRoute } from 'vue-router'
import { useCluesStore } from '@/stores/clues'
import { usePermissionsStore } from '@/stores/permissions'
import { useCurrentOpRole } from '@/composables/useCurrentOpRole'
import ClueList from '@/components/clues/ClueList.vue'
import AddClueModal from '@/components/clues/AddClueModal.vue'
import FosButton from '@/components/ui/FosButton.vue'
import PermissionGuard from '@/components/ui/PermissionGuard.vue'

const route = useRoute()
const incidentId = route.params.id as string
const cluesStore = useCluesStore()
const permissionsStore = usePermissionsStore()
const { opRole } = useCurrentOpRole()

const canLogClue = computed(() => permissionsStore.can('clues.log', opRole.value))
const showAddModal = ref(false)

cluesStore.subscribeToClues(incidentId)
onUnmounted(() => cluesStore.teardown())
</script>

<template>
  <AddClueModal
    v-model:visible="showAddModal"
    :incident-id="incidentId"
  />

  <div class="h-full flex flex-col overflow-hidden">
    <div class="flex items-center justify-between px-6 py-4 border-b border-border shrink-0">
      <div>
        <h2 class="font-headline font-black text-lg uppercase tracking-tight text-on-surface">Clues</h2>
        <p class="font-mono text-xs text-outline mt-0.5">
          {{ cluesStore.clues.length }} clue{{ cluesStore.clues.length !== 1 ? 's' : '' }} logged
        </p>
      </div>
      <PermissionGuard action="clues.log" :role="opRole">
        <FosButton variant="primary" @click="showAddModal = true">
          <span class="material-symbols-outlined text-[16px]">add</span>
          Log Clue
        </FosButton>
      </PermissionGuard>
    </div>

    <div class="overflow-y-auto px-6 pb-6 mt-4 flex-1">
      <ClueList
        :clues="cluesStore.clues"
        :incident-id="incidentId"
      />
    </div>
  </div>
</template>
